import styled from 'styled-components';
import Icon from '@mui/icons-material/Apple';
import { SignupButtonStyled } from '../create-account.styles';

export const AppleSignupButton = styled(SignupButtonStyled)`
  .MuiButton-startIcon {
    margin-top: -3px;

    .MuiSvgIcon-root {
      font-size: 30px;
    }
  }
`;

export const AppleIcon = styled(Icon)`
  width: 30px;
  height: 30px;
`;
